import React from 'react';
import { Tag } from 'antd';
import type { ImageDescriptor } from '@/api/ProductImages/types';
import { useTranslate } from '@/translations';
import { formatImageryTime } from '@/modules/ProductImages/GenerationRecord';

export const ImageSuspensionNotice = ({
  image,
}: {
  image?: Pick<ImageDescriptor, 'suspension'> | null;
}) => {
  const { t } = useTranslate();
  const suspension = image?.suspension;
  return suspension ? (
    <div
      className="imagery-suspension-notice"
      role="note"
      aria-label={t('imagery.imageSuspended')}
    >
      <Tag color="warning">{t('imagery.imageSuspended')}</Tag>
      <p>{suspension.reason}</p>
      <div>{suspension.suspendedBy}</div>
      <time dateTime={suspension.suspendedAtUtc}>
        {formatImageryTime(suspension.suspendedAtUtc)}
      </time>
    </div>
  ) : null;
};
